<div class="tabbable__body margin--none clearfix shadow-z-1">
  <div #headerPos>
    <div class="flex__container--seperate padding--2x">
      <h3>Här kan du administrera tillgängliga systemmeddelanden</h3>
      <button class="button info small float--right margin-top--1x" (click)="showNewSystemMessage(true)" scrollTo="newSystemMessage">Nytt meddelande</button>
    </div>
  </div>

    
    <div id="lists" class="row">
      <div class="col-12">
        <div class="tabbable__panel panel-padding clearfix shadow-z-1">
          <div class="col-12">
            <h3>Aktiva meddelanden</h3>
            <p class="text--black margin-top-bottom--2x">Kom ihåg att ta bort meddelanden med jämna mellanrum då alla aktiva meddelanden visas för nya Woo-användare!</p>
          </div>
        </div>
      </div>
      <app-woo-table [data]="systemMessages()" [loaderTpl]="loader">
        <woo-table-column header="Skapad" name="created_at">
          <ng-template #cell let-cell>
            {{cell.value | date: 'mediumDate'}}
          </ng-template>
        </woo-table-column>
        <woo-table-column header="Meddelande" name="message"></woo-table-column>
        <woo-table-column header="Typ" name="type">
          <ng-template #cell let-cell>
            @if(cell.value === 'info') {
              Information
            }
            @if(cell.value === 'warning') {
              Varning
            }
          </ng-template>
        </woo-table-column>
        <woo-table-column header="Roller" name="roles">
          <ng-template #cell let-cell>
            <span [innerHTML]="cell?.value?.length > 0 ? translatedRoles(cell.value).replaceAll(', ', '<br />') : '*'"></span>
          </ng-template>
        </woo-table-column>
        <woo-table-column header="" name="actions">
          <ng-template #cell let-cell>
            <button (click)="removeMessage(cell.row)" class="button danger margin--none float-end">
              <span class="icon-trash margin-right--1x"></span> Radera
            </button>
          </ng-template>
        </woo-table-column>
      </app-woo-table>

    </div>
  </div>
  <div class="row margin-top--3x large-bottom-block" id="newSystemMessage">
    @if(show.createMessageForm) {
    <div class="col-12 ">
        <woo-well>
          <h3>Skapa nytt meddelande</h3>
          <form (ngSubmit)="addMessage(newMessage)">
            <div class="input__container">
              <label for="text">Meddelande</label>
              <textarea id="text" type="text" name="text" [(ngModel)]="newMessage.message" required></textarea>
            </div>
            <div class="select__container">
              <label for="messageType">Typ</label>
              <select id="messageType" name="messageType" [(ngModel)]="newMessage.type" required>
                <option value='info'>Information</option>
                <option value='warning'>Varning</option>
              </select>
            </div>
            <div>
              <button type="button" class="link pull-left" (click)="selectAllRoles()">Välja Alla</button>
              <button type="button" class="link" (click)="deselectAllRoles()">Välj bort Alla</button>
            </div>
            <div class="row">
              @for(role of bookingRoles(); track $index) {
                <div class="input__container col-4">
                  <input type="checkbox" class="checkbox" name="role.userRole" [(ngModel)]="role.selected">
                  <label class="checkbox" for="role.userRole">{{role.label}}</label>
                </div>
              }
              <div class="clearfix"></div>
              <div class="divider medium margin-top-bottom--2x"></div>
              @for(role of noneBookingRoles(); track $index) {
                <div class="input__container col-4">
                  <input type="checkbox" name="role.userRole" class="checkbox" [(ngModel)]="role.selected">
                  <label for="role.userRole" class="checkbox">{{role.label}}</label>
                </div>
              }
              <div class="clearfix"></div>
            </div>
            <div>
              <button type="submit" class="button pull-left" [disabled]="disableSubmit(newMessage)">Skapa</button>
              <button type="button" class="link" (click)="cancelNewMessage() && showNewSystemMessage(true, headerPos)">Avbryt</button>
            </div>
          </form>
      </woo-well>
    </div>
  }
</div>

<ng-template #loader let-data>
  @if(loading()) {
      <div class="text-center w-100">
        <dot-loader [large]="true"></dot-loader>
      </div>
    } @else {
      <span>Det finns inga meddelanden att visa</span>
    }
</ng-template>
